<div class="flex items-center justify-center min-h-screen bg-drfeel-gradient p-5">
  <div class="w-full max-w-[500px] bg-white rounded-[20px] shadow-lg pt-12 pb-10 px-8 lg:px-16 text-center">
    <!-- Logo -->
    <div class="flex justify-center mb-10">
      <img
        class="h-10"
        src="images/logo-drfeel-gradient.svg"
        alt="Logo Dr.Feel"
      />
    </div>

    <div class="border-t border-gray-100 pt-10">
      <h1 class="text-[24px] leading-[30px] text-lightBlack font-bold mb-8">
        Iscriviti per utilizzare il servizio
      </h1>

      <!-- Form -->
      <form
        class="flex flex-col mb-12"
        [formGroup]="selectCompanyForm"
        (ngSubmit)="onSubmit()"
      >
        <!-- Email -->
        <div class="flex flex-col mb-8 text-left">
          <label
            for="email"
            class="mb-3 text-[14px] leading-[14px] text-darkGray font-medium"
          >
            Inserisci l'e-mail aziendale
          </label>
          <input
            id="email"
            type="email"
            formControlName="email"
            class="rounded-lg px-5 py-4 bg-[#EDEDED] text-[15px] leading-[15px] font-medium focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition placeholder:text-gray-400"
            placeholder="emailaziendale@com"
          />
          <div
            *ngIf="
              selectCompanyForm.get('email')?.invalid &&
              selectCompanyForm.get('email')?.touched
            "
            class="text-red-500 text-sm mt-2"
          >
            E-mail non valida.
          </div>
        </div>

        <!-- Submit -->
        <button
          type="submit"
          [disabled]="selectCompanyForm.invalid"
          class="w-full bg-drfeel py-4 rounded-lg text-white text-[18px] leading-[135%] uppercase font-bold disabled:opacity-20 disabled:cursor-not-allowed transition-all hover:brightness-110"
        >
          Avanti
        </button>
      </form>

      <!-- Footer -->
      <p class="text-[14px] font-medium text-lightBlack">
        Hai già un account?
        <a href="https://app.drfeel.com" target="_blank" class="text-drfeel font-bold hover:underline cursor-pointer">
          Accedi
        </a>
      </p>
    </div>
  </div>
</div>

